var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-icon-wrap",on:{"click":_vm.open}},[_c('SvgIcon',{staticClass:"header-icon",attrs:{"name":"language"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }